import "../Custom.css"
import ServicesPage from "./ServicesPage"
import {
  INT_COMMERCE_PAGE_IMAGE_FIVE,
  INT_COMMERCE_PAGE_IMAGE_FOUR,
  INT_COMMERCE_PAGE_IMAGE_ONE,
  INT_COMMERCE_PAGE_IMAGE_SIX,
  INT_COMMERCE_PAGE_IMAGE_THREE,
  INT_COMMERCE_PAGE_IMAGE_TWO,
} from "../utils/constants"

const IntCommerce = () => {
  const leftColumnData = []

  const rightColumnData = [
    {
      title: "Clothing & Accessories",
      desc: "Experience curated fashion and accessories sourced for excellence. Elevate your style with our diverse selection, offering trendy apparel and accessories crafted to enhance your unique personality and preferences.",
      imgPath: INT_COMMERCE_PAGE_IMAGE_SIX,
    },
  ]

  return (
    <>
      <ServicesPage prop={{ leftColumnData, rightColumnData }} />
    </>
  )
}

export default IntCommerce
